
import axios from 'axios';
import { Customencryptdata } from '../hooks/CustomData'
import crypto from '../hooks/crypto';
let BASE_URL = 'https://backend-kevlar.maticz.in';
// let BASE_URL = 'http://localhost:2078';

let secretKey = crypto.cryptoSecretKey

export const acceptInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/acceptInvite`, {
            token: data
        });
        console.log("respData", respData);


        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
        }

    } catch (error) {
        console.log(error, "acceptInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}


export const rejectInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/rejectInvite`, {
            token: data
        });
        console.log("respData", respData);


        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
        }

    } catch (error) {
        console.log(error, "rejectInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}

export const verifyInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/verifyInvite`, {
            token: data
        });
        console.log("respData", respData);


        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
        }

    } catch (error) {
        console.log(error, "verifyInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}


export const IndentifyUserData = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/IndentifyUser`, {
            token: data
        });
        console.log("respData", respData);


        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
            result: respData?.data?.data
        }

    } catch (error) {
        console.log(error, "IndentifyUserData")
        return {
            status: false,
            message: error.response.data,
        };
    }
}


export const TerminateRecoveryKeyInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/terminateRecoveryKeyInvitation`, {
            token: data
        });
        console.log("respData", respData);

        return {
            status: respData?.data?.status,
            message: respData?.data?.message
        }

    } catch (error) {
        console.log(error, "TerminateRecoveryKeyInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}

export const acceptNomineeInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/acceptNomineeInvite`, {
            token: data
        });
        console.log("respData", respData);

        return {
            status: respData?.data?.status,
            message: respData?.data?.message
        }

    } catch (error) {
        console.log(error, "acceptNomineeInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}

export const declineNomineeInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/declineNomineeInvite`, {
            token: data
        });
        console.log("respData", respData);

        return {
            status: respData?.data?.status,
            message: respData?.data?.message
        }

    } catch (error) {
        console.log(error, "declineNomineeInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}

export const TerminateInheritanceInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/terminateNomineeInvite`, {
            token: data
        });
        console.log("respData", respData);

        return {
            status: respData?.data?.status,
            message: respData?.data?.message
        }

    } catch (error) {
        console.log(error, "TerminateInheritanceInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}



export const acceptReplaceInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/acceptReplaceInvite`, {
            token: data
        });
        console.log("respData", respData);

        return {
            status: respData?.data?.status,
            message: respData?.data?.message
        }

    } catch (error) {
        console.log(error, "acceptReplaceInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}

export const declineReplaceInvitation = async (data) => {
    try {

        const respData = await axios.post(`${BASE_URL}/user/declinetReplaceInvite`, {
            token: data
        });
        console.log("respData", respData);

        return {
            status: respData?.data?.status,
            message: respData?.data?.message
        }

    } catch (error) {
        console.log(error, "declineReplaceInvitation")
        return {
            status: false,
            message: error.response.data,
        };
    }
}
